
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexHnxXdhBNdQubnxXcIw9buCgWWyLYHCUWGsJYoovz83YMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/index.vue?macro=true";
import { default as pricingBnmm_5rCyy9LGDZwklPBy4vCtgh2wV2dscsFZ00ZAqMMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/pricing.vue?macro=true";
import { default as indexfbGiOzieuI2NTPVZjidvYYadeYpsucwR5gvwipWQCukMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/blog/index.vue?macro=true";
import { default as terms_45of_45useZCDh9R5JZxyrxQvQBOKwXNHEDT6DNt8El3JgdlihRsMMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/terms-of-use.vue?macro=true";
import { default as cookie_45policyKaX9FwqVYDXSe8DgdBiD_45Cj8PoOUAscrDfmCNDp4aKMMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/cookie-policy.vue?macro=true";
import { default as _91_46_46_46slug_938kl41_CcWynmuX9qHtP9jakEroJKkXXf3DTXz5NbafEMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/blog/[...slug].vue?macro=true";
import { default as privacy_45policy2HiFRGojKPecmHyi8CS5Jr64RBjrBIf8Bh52OX0ZtaMMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/privacy-policy.vue?macro=true";
import { default as indexvOwdhDuktobgz0XzX_45ZUZUb3j6PoH3c7vU30IWemiYkMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/products/index.vue?macro=true";
import { default as index1qol9bP_4552qvzdPl6aLtoJHOWBTYEnHo5_45NUw1ZWGQwMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/solutions/index.vue?macro=true";
import { default as mail_45list_45thanksG_45ZlOfvsLQbRMkNSX8oah3uV5ZNdC09NIrI7JUa1n0EMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/mail-list-thanks.vue?macro=true";
import { default as mail_45list_45confirmk_PFv3zHlMV3JAH4WgLzojJA3NYAgFaQmMUWIVcAKcsMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/mail-list-confirm.vue?macro=true";
import { default as monitoringked6wgkrHiLqk_ggD_bhBUVJ5OImhcFnm5jK7Sw0_FcMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/products/monitoring.vue?macro=true";
import { default as engineersHgLLk8ke1UmOhcyqcJhsy9bz6L2bELm4Nczn_45Yjyy4cMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/solutions/engineers.vue?macro=true";
import { default as surveyorsw5xCHgC2SISSdRnX8NtHRNxxzn0db9FDS1frWWxDUc0Meta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/solutions/surveyors.vue?macro=true";
import { default as section_45ideasQ22LeVtL14LCDSXY1rq_45ZN_5gDk8lSw4Fu2arro_5bwMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/_ideas/section-ideas.vue?macro=true";
import { default as architects92AVmetdYP0xp4WCXCsJoPzQ4w9jIwQu_45yFpsiGA7xMMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/solutions/architects.vue?macro=true";
import { default as developersyLdMleFzr5BwxqDAp1u_rNSP28yaeBLk5_45QjatjjqioMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/solutions/developers.vue?macro=true";
import { default as data_45storageRIrS1KV4HxIu7GM4JB7LJ5TdA_ApRsKBLYfcKCEzEiAMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/products/data-storage.vue?macro=true";
import { default as consultantsSndJSoYrviKynw6lj94uNiMSd05tzXNLiCIgsrtDaSEMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/solutions/consultants.vue?macro=true";
import { default as contractors6TscB7NceUNkods6EZjXqun2K_45kJEgdqmiCI8WQLn7UMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/solutions/contractors.vue?macro=true";
import { default as visualisationXqpo2P0kB1my2y6lRbVhuNj1rVV4e79sK4BsZF6BixMMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/products/visualisation.vue?macro=true";
import { default as asset_45ownersb85nfPZ59ygoGM_45_45lNtj6X2g9PsxtAbNPIlVHu3zdvAMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/solutions/asset-owners.vue?macro=true";
import { default as collaborate_45annotateD_PPJ2vujxf_KbTIZizlaclQPwf7prZef_PeN8zz3fgMeta } from "/home/runner/work/engage-web/engage-web/apps/site/src/pages/products/collaborate-annotate.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/index.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/pricing.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/blog/index.vue")
  },
  {
    name: "terms-of-use",
    path: "/terms-of-use",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/terms-of-use.vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/cookie-policy.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug(.*)*",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/blog/[...slug].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/privacy-policy.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/products/index.vue")
  },
  {
    name: "solutions",
    path: "/solutions",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/solutions/index.vue")
  },
  {
    name: "mail-list-thanks",
    path: "/mail-list-thanks",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/mail-list-thanks.vue")
  },
  {
    name: "mail-list-confirm",
    path: "/mail-list-confirm",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/mail-list-confirm.vue")
  },
  {
    name: "products-monitoring",
    path: "/products/monitoring",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/products/monitoring.vue")
  },
  {
    name: "solutions-engineers",
    path: "/solutions/engineers",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/solutions/engineers.vue")
  },
  {
    name: "solutions-surveyors",
    path: "/solutions/surveyors",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/solutions/surveyors.vue")
  },
  {
    name: "_ideas-section-ideas",
    path: "/_ideas/section-ideas",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/_ideas/section-ideas.vue")
  },
  {
    name: "solutions-architects",
    path: "/solutions/architects",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/solutions/architects.vue")
  },
  {
    name: "solutions-developers",
    path: "/solutions/developers",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/solutions/developers.vue")
  },
  {
    name: "products-data-storage",
    path: "/products/data-storage",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/products/data-storage.vue")
  },
  {
    name: "solutions-consultants",
    path: "/solutions/consultants",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/solutions/consultants.vue")
  },
  {
    name: "solutions-contractors",
    path: "/solutions/contractors",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/solutions/contractors.vue")
  },
  {
    name: "products-visualisation",
    path: "/products/visualisation",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/products/visualisation.vue")
  },
  {
    name: "solutions-asset-owners",
    path: "/solutions/asset-owners",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/solutions/asset-owners.vue")
  },
  {
    name: "products-collaborate-annotate",
    path: "/products/collaborate-annotate",
    component: () => import("/home/runner/work/engage-web/engage-web/apps/site/src/pages/products/collaborate-annotate.vue")
  }
]